import React, { useState } from 'react';
import styles from './Header.module.css';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMenuOpen(false); // Close mobile menu after navigation
    }
  };

  const handleLogoClick = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  const handleHomeClick = (e) => {
    e.preventDefault();
    scrollToSection('home');
  };

  const handleContactClick = (e) => {
    e.preventDefault();
    scrollToSection('contact');
  };

  return (
    <header className={styles["header"]}>
      <div className={styles["header-container"]}>
        <div className={styles["header-left"]}>
          <a href="#home" onClick={handleLogoClick} className={styles["logo"]}>
            LifeInPXL
          </a>
        </div>
        
        <nav className={`${styles["nav"]} ${isMenuOpen ? styles["nav-open"] : ""}`}>
          <a href="#home" onClick={handleHomeClick} className={styles["nav-link"]}>Home</a>
          <a href="#contact" onClick={handleContactClick} className={styles["nav-link"]}>Contact</a>
        </nav>

        <button 
          className={styles["menu-toggle"]}
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <span className={styles["menu-icon"]}></span>
          <span className={styles["menu-icon"]}></span>
          <span className={styles["menu-icon"]}></span>
        </button>
      </div>
    </header>
  );
};

export default Header;

